import React from "react";
import VideoComponent from "../util/VideoComponent";

const VideosComponent = (props) => {
    return (
        <div>
            {/*Videos*/}
            {/*  From Permanent Collection  */}
            <VideoComponent id="NANINTV083" src={process.env.PUBLIC_URL + `/videos/NANINTV083.mp4`}/>
            {/*  From Permanent Collection  */}

            {/*Audio*/}
            {/*  From Permanent Collection  */}
            <VideoComponent id="NANINTA083" src={process.env.PUBLIC_URL + `/audio/NANINTA083.mp3`} audio="Y"/>
            {/*  From Permanent Collection  */}
            <VideoComponent id="ARM_CAD_A001_ARM" src={process.env.PUBLIC_URL + `/audio/ARM_CAD_A001_ARM.mp3`} audio="Y"/>
            <VideoComponent id="ARM_INT_A046_ARM" src={process.env.PUBLIC_URL + `/audio/ARM_INT_A046_ARM.mp3`} audio="Y"/>
            <VideoComponent id="ARM_POS_A027_ARM" src={process.env.PUBLIC_URL + `/audio/ARM_POS_A027_ARM.mp3`} audio="Y"/>
            <VideoComponent id="ARM_REL_A002_ARM" src={process.env.PUBLIC_URL + `/audio/ARM_REL_A002_ARM.mp3`} audio="Y"/>
            <VideoComponent id="ARM_REL_A003_ARM" src={process.env.PUBLIC_URL + `/audio/ARM_REL_A003_ARM.mp3`} audio="Y"/>
            <VideoComponent id="ARM_REL_A005_ARM" src={process.env.PUBLIC_URL + `/audio/ARM_REL_A005_ARM.mp3`} audio="Y"/>
            <VideoComponent id="ARM_REL_A007_ARM" src={process.env.PUBLIC_URL + `/audio/ARM_REL_A007_ARM.mp3`} audio="Y"/>
            <VideoComponent id="ARM_SRD_A048_ARM" src={process.env.PUBLIC_URL + `/audio/ARM_SRD_A048_ARM.mp3`} audio="Y"/>

            {/*<VideoComponent id="S02P07A01" src={process.env.PUBLIC_URL + `/audio/S02P07A01.mp3`} audio="Y"/>*/}


        </div>
    )
}

export default VideosComponent;
